<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon v-bind="attrs" v-on="on">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</template>
		<div v-for="item in menulists_filter"
			:key="item.key"
			@click.stop="onClickMenuItem(item.key)" 
			@mouseover="item.isHover = true"
			@mouseout="item.isHover = false"
			class="d-print-none" >
			<div class="menu-item " :class="item.usable ? 'menu-able':'menu-delete-disable'">
				<component 
					:is="item.icon"
					:color="item.color"
					:selected="item.isHover" 
					:selected_color="`#192A3E`"
					width="18"
					height="18"
					class="mr-3" 
				/>
				{{ item.title }}
			</div>
		</div>
		<div class="d-print-none menu-delete" :class="deleteColor" 
			@click.stop="onDelete()" 
			@mouseover="isHover = true"
			@mouseout="isHover = false">
			<Delete
				width="20"
				height="20"
				class="mr-2" 
				style="margin-left: 2px; margin-top: 1px;"
				:color="deleteIconColor"
				:selected="isHover" 
				:selected_color="deleteSelectedColor"/>
			<div>Delete</div>
		</div>
	</v-menu>
</template>
<script>
import MoreHoriz from "@/components/icons/more-horiz";
import Rename from '@/components/icons/rename';
import Copy from '@/components/icons/copy';
import Share from '@/components/icons/share';
import Delete from '@/components/icons/delete_outline';
import Tick from '@/components/icons/tick';
import Item from '@/components/icons/item';


const SHOW_COLOR = '#192A3E';
const SELECTED_COLOR = '#F45252';

const MENU_LIST = [
	{
		key: 'edit',
		title: 'Edit',
		icon: Rename,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: []
	},
	{
		key: 'duplicate',
		title: 'Duplicate',
		icon: Copy,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: []
	}
];

export default {
	name: 'TaskCalendarItemMenu',
	props: {
		color: {
			type: String,
			default: 'rgba(25, 42, 62, 0.7)'
		},
	},
	data() {
		this.selected_color = SELECTED_COLOR;

		return {
			menu_list: MENU_LIST,
			isHover: false,
		}
	},
	components: {
		MoreHoriz,
		Rename,
		Copy,
		Share,
		Delete,
		Tick,
		Item
	},
	computed: {
		menulists_filter () {
			return this.menu_list;
		},
		deleteColor() {
			return 'menu-delete-able';
		},
		deleteIconColor() {
			return SHOW_COLOR;
		},
		deleteSelectedColor() {
			return SELECTED_COLOR;
		}
	},
	methods: {
		onClickMenuItem(key) {
			this.$emit('click-menu-item', key)
		},
		onDelete() {
			this.$emit('delete');
		}
	}
}
</script>
<style lang="scss" scoped>
.menu-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-able {
	color: #192A3E;
	&:hover {
		background: #E8EAEC;
		cursor: pointer;
	}
}
.menu-delete {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
 	padding: 8px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-delete-able {
	color: #192A3E;
  &:hover {
    color: #F45252;
		background: #E8EAEC;
    cursor: pointer;
  }
}
.menu-delete-disable {
  color: #82899B;
}

</style>